module.exports = __webpack_public_path__ + "static/img/navi_code.543e39cc.jpg";